type MockEmployee = {
  employeeId: string;
  recordStartDate: string;
  name: string;
  role: string;
  kronosId: string | null;
  pictureUrl: string | null;
  pictureLastModified: string | null;
  recordEndDate: string | null;
  kronosHireDate: string | null;
  kronosStartDate: string | null;
  kronosTermDate: string | null;
  locationCode: string | null;
};

/** Raw API response — date fields are ISO strings before the Axios handleDates interceptor. */
export const mockEmployees: {
  totalEmployeeCount: number;
  employees: MockEmployee[];
} = {
  totalEmployeeCount: 5,
  employees: [
    {
      employeeId: "H00001",
      recordStartDate: "2024-07-09T00:08:30",
      name: "Test User",
      role: "Supervisor",
      kronosId: "1234",
      pictureUrl: null,
      pictureLastModified: null,
      recordEndDate: null,
      kronosHireDate: "2024-07-09T00:08:30",
      kronosStartDate: "2024-07-09T00:08:30",
      kronosTermDate: null,
      locationCode: "LAX",
    },
    {
      employeeId: "H00002",
      recordStartDate: "2024-07-15T00:08:00",
      name: "John Doe",
      role: "Dock Worker",
      kronosId: null,
      pictureUrl: null,
      pictureLastModified: null,
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
      locationCode: "LAX",
    },
    {
      employeeId: "H00003",
      recordStartDate: "2024-07-15T00:08:00",
      name: "Bee Hive",
      role: "Dock Worker",
      kronosId: null,
      pictureUrl: null,
      pictureLastModified: null,
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
      locationCode: "EWR",
    },
    {
      employeeId: "H00004",
      recordStartDate: "2024-07-15T00:08:00",
      name: "Aaron Smith",
      role: "Dock Worker",
      kronosId: null,
      pictureUrl: null,
      pictureLastModified: null,
      recordEndDate: null,
      kronosHireDate: null,
      kronosStartDate: null,
      kronosTermDate: null,
      locationCode: "EWR",
    },
    {
      employeeId: "H00005",
      recordStartDate: "2024-07-09T00:08:30",
      name: "Without Picture",
      role: "Supervisor",
      kronosId: "1234",
      pictureUrl: null,
      pictureLastModified: null,
      recordEndDate: null,
      kronosHireDate: "2024-07-09T00:08:30",
      kronosStartDate: "2024-07-09T00:08:30",
      kronosTermDate: null,
      locationCode: "LAX",
    },
  ],
};
